export default "__VITE_ASSET__CUi5Bu3i__"